const DEFAULT_GRAPH_EXPRESSION = 'y=x^2';

const toSafeString = (value) => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return '';
};

export const normalizeGraphExpressions = (rawValue, fallback = DEFAULT_GRAPH_EXPRESSION) => {
  if (typeof rawValue === 'string') {
    const normalized = rawValue.trim();
    return normalized || fallback;
  }

  if (Array.isArray(rawValue)) {
    const joined = rawValue
      .map((item) => toSafeString(item).trim())
      .filter(Boolean)
      .join('\n');
    return joined || fallback;
  }

  if (rawValue && typeof rawValue === 'object') {
    const candidates = [
      rawValue.expressions,
      rawValue.expression,
      rawValue.latex,
      rawValue.value,
      rawValue.content,
    ];
    for (const candidate of candidates) {
      const normalized = normalizeGraphExpressions(candidate, '');
      if (normalized) return normalized;
    }
    return fallback;
  }

  const primitive = toSafeString(rawValue).trim();
  return primitive || fallback;
};

export const parseGraphExpressions = (rawValue) => {
  const normalized = normalizeGraphExpressions(rawValue, '');
  if (!normalized) return [];
  return normalized
    .split('\n')
    .map((entry) => entry.trim())
    .filter(Boolean);
};

export { DEFAULT_GRAPH_EXPRESSION };
